/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import server from '../../_api/backend';
import { AsideBook } from '../../_layout/aside-book';
import { Pagenation } from '../../_component/pagenation';
import { FormatToComma } from '../../_component/format-to-comma';
import { Category } from '../../_store/slice/book-categories';
import { ReducerType } from '../../_store';
import * as toast from '../../_store/slice/toast';
// import { getBreadScrumb } from '../board/breadscrumb';

type Params = {
  id: number;
};

export function BookMain(props: RouteComponentProps) {
  const dispatch = useDispatch();
  const [
    pageInfo = { total: 10, rowCount: 10, page: 1, totalPages: 1 },
    setPageInfo,
  ] = useState<any>();
  const { id } = props.match.params as Params;
  const [booksCategory = [], setBooksCategory] = useState<any>();

  const [maincateId, setMaincateId] = useState<number>();
  const [subcateId, setSubcateId] = useState();

  const bookCategories = useSelector<ReducerType, Category>((state) => state.bookCategories);

  useEffect(() => {
    getBooksCategory();
    getMainandSubCateId();
  }, [id, maincateId]);

  // 서브 카테고리 최상위 ID 값을 넣기위한 배열
  const arr: any[] = [];

  const getMainandSubCateId = async () => {
    bookCategories.categories.forEach((main: any, idx: any) => {
      if (main.id === id) {
        setMaincateId(+main.id);
        bookCategories.subCategories[idx].forEach((sub: any) => {
          arr.push(sub);
          for (let i = 0; i < arr.length; i++) {
            setSubcateId(arr[0].id);
          }
        });
      }
    });
  };

  const getBooksCategory = async () => {
    switch (+id || maincateId) {
      case maincateId:
        props.history.push(`/book-categories/${subcateId}/books`);
        break;
      default:
        await server
          .getBooksCategories(id, 1, 25, 'Y')
          .then((payload) => {
            const { meta } = payload;
            setBooksCategory(payload.items);
            setPageInfo({
              total: meta.totalItems,
              rowCount: meta.itemsPerPage,
              page: meta.currentPage,
              totalPages: meta.totalPages,
            });
          })
          .catch((error) => {
            dispatch(
              toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
            );
            console.log(error);
          });
        break;
    }
  };

  const onClickPage = async (pageParam: any) => {
    await server
      .getBooksCategories(+id, pageParam.page, pageParam.rowCount)
      .then((payload) => {
        const { meta } = payload;
        setBooksCategory(payload.items);
        setPageInfo({
          total: meta.totalItems,
          rowCount: meta.itemsPerPage,
          page: meta.currentPage,
          totalPages: meta.totalPages,
        });
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  return (
    <main className="sub wrapper">
      <AsideBook mainId={maincateId} />
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          {bookCategories.categories.map((category: any, i: any) => (
            <span key={category.id}>
              <> {category.id === id ? category.name : ''}</>
              {bookCategories.subCategories[i].map((book: any) => (
                <span key={Math.random()}>{book.id === id ? book.name : ''}</span>
              ))}
            </span>
          ))}
          {/* <Link to="#">카테고리</Link> */}
        </div>
        <div className="title">
          <h2>도서 목록</h2>
          <p>구민사는 오랫동안 사랑을 받아온 신기술 서적 전문 출판사입니다.</p>
        </div>
        <div className="items">
          {booksCategory.map((book: any) => (
            <Link key={book.id} to={`/books/${book.id}`}>
              <img
                src={`${process.env.REACT_APP_API_URL}/public${book.imageMiddleUrl}`}
                alt={book.name}
              />
              <ul>
                <li>{book.name}</li>
                <li>{book.author}</li>
                <li>{FormatToComma(book.price)}원</li>
              </ul>
            </Link>
          ))}
        </div>
        {pageInfo ? (
          <Pagenation PageInfo={pageInfo} PagenationHandler={onClickPage} IsFirstEndArrow />
        ) : (
          ''
        )}
      </div>
    </main>
  );
}
